var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.1537 56.8C58.14 56.7265 51.3401 54.5477 45.7701 50.5892C40.2001 46.6306 36.1589 41.1048 34.2504 34.8374C32.3419 28.57 32.6684 21.8974 35.1813 15.8166C37.6942 9.73573 42.2584 4.57309 48.1922 1.1C45.1939 0.376266 42.1093 0.00668047 39.0114 0C29.0148 0 19.4276 3.68749 12.3589 10.2513C5.29023 16.815 1.31909 25.7174 1.31909 35C1.31909 44.2826 5.29023 53.185 12.3589 59.7487C19.4276 66.3125 29.0148 70 39.0114 70C44.6745 69.9953 50.2617 68.7902 55.3473 66.4767C60.4329 64.1632 64.8827 60.8023 68.3576 56.65C67.293 56.7505 66.2237 56.8005 65.1537 56.8V56.8Z",
    fill: "#090057"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.9c2ab249ea3fcef37b6969c58305fc59.svg";
export { ForwardRef as ReactComponent };